import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var FailedFetchError = /*#__PURE__*/function (_Error) {
  _inherits(FailedFetchError, _Error);
  var _super = _createSuper(FailedFetchError);
  function FailedFetchError(_ref) {
    var _this;
    var error = _ref.error,
      path = _ref.path,
      method = _ref.method;
    _classCallCheck(this, FailedFetchError);
    _this = _super.call(this);
    _this.name = 'FailedFetchError';
    _this.message = error.message || 'Unknown fetch error';
    _this.stack = error.stack;
    _this.originalName = error.name;
    _this.method = method;
    var p = path.split('?')[0];
    _this.path = /^[/-a-z]+$/i.test(p) ? p : '';
    return _this;
  }
  return _createClass(FailedFetchError);
}( /*#__PURE__*/_wrapNativeSuper(Error));
export { FailedFetchError as default };